/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2022-05-25 10:11:34
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-04-23 17:58:08
 * @FilePath: \githubd:\工作代码\nuxt-h5\assets\js\getLocation.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
let wx = require('weixin-js-sdk')

const pageConfig = require('@/api/config');

export function getWxSdk() {
    const formdata = new FormData();
    formdata.append('url', window.location.href.split('#')[0]); //进入小程序首页的url
    axios({
        method: 'post',
        url: "weixinwiki/sharetoken",
        data: formdata,
        responseType: 'json',
        baseURL: pageConfig.root,
    }).then(res => {
        res = res.data;
        wx.config({
            beta: true,
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见附录1
            jsApiList: [
                "openLocation",
                "getLocation",
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        wx.error((err) => {
            console.log(err)
        })

        wx.ready(() => { });
    })
}

// Vue.use(WechatPlugin)
function getLocations(name, lng, lat) {
    wx.openLocation({
        fail(fail) {
            console.log('fail', fail)
        },
        latitude: parseFloat(lat), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(lng), // 经度，浮点数，范围为180 ~ -180。
        name: name, // 位置名
        address: '', // 地址详情说明
        scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
    });
}

export function navigateto(data) {
    wx.miniProgram.navigateTo({
        url: data.url
    });
}




export default getLocations


// WEBPACK FOOTER //
// ./src/assets/js/getLocation.js